import { Component, inject } from "@angular/core";
import { DialogRef, DIALOG_DATA, ForgeButtonModule, ForgeCardModule, ForgeDialogModule } from "@tylertech/forge-angular";

export interface AlertDialogData
{
    readonly title?: string;
    readonly message: string;
    readonly okLabel?: string;
}

@Component({
    selector: "simple-alert-dialog",
    imports: [
        ForgeCardModule,
        ForgeButtonModule,
        ForgeDialogModule,
    ],
    template: `<forge-card>
    <h2 mat-dialog-title>{{title}}</h2>

    <div [innerHtml]="message"></div>

    <div fxFlex fxLayout="end center" fxLayoutGap="1em">
        <forge-button variant="raised" (click)="onClick()" telemetry="Submission-Save" selenium-tag="save-btn">
            {{okLabel}}
        </forge-button>
    </div>
</forge-card>
`,
    styles: []
})
export class SimpleAlertDialogComponent
{
    private readonly dialogRef = inject(DialogRef);
    private readonly data = inject<AlertDialogData>(DIALOG_DATA);


    get title(): string { return this.data.title ?? "Error"; }
    get message(): string { return this.data.message; }
    get okLabel(): string { return this.data.okLabel ?? "OK"; }

    onClick(): void
    {
        this.dialogRef.close();
    }
}
